import { useAuthContext } from '@/contexts/AuthContext';

export function useUserProfile() {
  const { user, loading, role } = useAuthContext();

  // Gerar iniciais do nome
  const getInitials = (name: string | undefined): string => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(part => part.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  };

  // Determinar tipo de cliente baseado no papel
  const getClientType = (userRole: string | null): string => {
    switch (userRole) {
      case 'super_administrador':
        return 'Super Admin';
      case 'administrador':
        return 'Administrador';
      case 'profissional':
        return 'Profissional';
      case 'teste_profissional':
        return 'Profissional (Teste)';
      case 'teste_usuario':
        return 'Cliente (Teste)';
      case 'usuario':
      default:
        return 'Cliente';
    }
  };

  // Obter primeiro nome para saudação
  const getFirstName = (name: string | undefined): string => {
    if (!name) return 'Usuário';
    return name.split(' ')[0];
  };

  // Obter nome de exibição (apelido ou nome)
  const getDisplayName = (): string => {
    if (user?.profile?.apelido) return user.profile.apelido;
    if (user?.profile?.nome) return user.profile.nome;
    return 'Usuário';
  };

  // Obter avatar URL
  const getAvatarUrl = (): string | null => {
    return user?.profile?.avatar_url || null;
  };

  return {
    user,
    loading,
    role,
    profile: user?.profile || null,
    displayName: getDisplayName(),
    firstName: getFirstName(user?.profile?.nome),
    initials: getInitials(user?.profile?.nome),
    avatarUrl: getAvatarUrl(),
    clientType: getClientType(role),
    isAuthenticated: !!user,
  };
}